var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.show ? 'show' : 'hide'},[_c('ul',{staticClass:"list ul-h"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.funcClicked(index)}}},[_vm._v(" "+_vm._s(item)+" "),_c('div',{class:['sepline', index == _vm.list.length-1 ? 'sepline-hide' : 'sepline-show']})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }